import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LoginButton } from '../components/LoginButton/LoginButton';
import { useAppSelector } from '../redux/hooks';
import { selectUser } from '../redux/reducers/userSlice';
import { Roles } from '../models/User';
import DashboardStudent from './DashboardStudent';
// import DashboardTeacherOrSiteAdmin from './DashboardTeacherOrSiteAdmin';
import TeacherWelcomeWrapper from '../components/TeacherDashboard/TeacherWelcome/TeacherWelcomeWrapper';
import { useUserActionMutation } from '../custom-hooks/useUserActionMutation';
import { saveLoginUserActionRetry } from '../businessLogicService/saveLoginUserActionRetry';

const Dashboard: FC = () => {
  const userRedux = useAppSelector(selectUser);
  // A new key for every navigation entry, including a <Link to="/"> click while already on "/".
  // Remounting the student dashboard on it makes a same-route navigation re-run the mount-time
  // initialization (DashboardHeader seeding the skill states, DashboardContainerBody deriving the
  // unit path) exactly like arriving from another route does — otherwise the tree is only
  // re-rendered, the selected unit changes underneath it and the unit path keeps the previous unit.
  const { key: locationKey } = useLocation();
  const [isInferred, setIsInferred] = useState<boolean>(false);
  const roles = [Roles.TEACHER, Roles.SITE_ADMIN];
  const isTeacherOrSiteAdmin = userRedux?.roles?.some(role => roles.includes(role?.name));
  const isNetworkAdmin = userRedux?.roles.some(role => role.name === Roles.NETWORK_ADMIN);

  const [commitLoginMutation] = useUserActionMutation();
  const currentUrl = window.location.href;

  useEffect(() => {
    window?.userGuiding?.identify(userRedux?.sub ?? '', {
      enviro: currentUrl,
      user_hash: userRedux?.userGuidingHash ?? '',
    });
  }, []);

  useEffect(() => {
    const loginFlag = sessionStorage.getItem('track_login_action');
    if (loginFlag === 'true' && userRedux) {
      const userAction = {
        userId: `UserNode:${userRedux?.id}`,
        actionTypeId: 'ActionTypeNode:1',
        timeStamp: new Date().toISOString(),
        description: 'login',
      };
      saveLoginUserActionRetry({
        saveUserAction: commitLoginMutation,
        payload: userAction,
        maxRetries: 4,
        baseDelay: 2000,
      });
    }
    sessionStorage.removeItem('track_login_action');
  }, [userRedux]);

  return (
    <div className="nc_page-inner">
      {!userRedux && <LoginButton />}
      {userRedux && userRedux.gradeLevel && !isTeacherOrSiteAdmin && !isNetworkAdmin && (
        <DashboardStudent key={locationKey} isInferred={isInferred} setIsInferred={setIsInferred} />
      )}
      {/* {userRedux && (isTeacherOrSiteAdmin ||  isNetworkAdmin)&&  <DashboardTeacherOrSiteAdmin />} */}
      {userRedux && (isTeacherOrSiteAdmin || isNetworkAdmin) && (
        <TeacherWelcomeWrapper isNetworkAdmin={isNetworkAdmin} />
      )}
    </div>
  );
};

export default Dashboard;
